import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// The installed TWA passes its version in the launch URL (?appVersion=N). Capture it once on load
// (before any client-side navigation strips the query) so the "Check for updates" button can tell
// whether a newer APK is available.
try {
  const appVersion = new URLSearchParams(window.location.search).get("appVersion");
  if (appVersion) localStorage.setItem("installedApkVersion", appVersion);
} catch (e) {}

// Tell the service worker this phone uses the installed Android app, so call
// updates there arrive as separate notifications (Android groups them);
// elsewhere they keep replacing each other. Read in sw.js isApkDevice().
try {
  const apk = localStorage.getItem("installedApkVersion");
  if (apk && "indexedDB" in window) {
    const req = indexedDB.open("CHSPSettings", 2);
    req.onupgradeneeded = (e) => {
      const db = e.target.result;
      if (!db.objectStoreNames.contains("settings")) db.createObjectStore("settings", { keyPath: "id" });
    };
    req.onsuccess = (e) => {
      try {
        e.target.result.transaction(["settings"], "readwrite").objectStore("settings").put({ id: "device", apk: Number(apk) || 1 });
      } catch (err) { /* store not ready */ }
    };
  }
} catch (e) {}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Register Service Worker for PWA
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js')
      .then((registration) => {
        console.log('CHSP SW registered:', registration.scope);
      })
      .catch((error) => {
        console.log('CHSP SW registration failed:', error);
      });
  });
}
